module.exports = __webpack_public_path__ + "img/logo-bd.c338cd94.png";